import React from "react"
import clsx from "clsx"
import RoomTypeBuilderErrors from "../RoomTypeBuilderErrors"
import MultiSelect from "../../Selects/MultiSelect"

class RoomTypeBuilderRoomGroups extends React.Component {

  constructor(props) {
    super(props)
    this.renderErrors = this.renderErrors.bind(this)
  }

  render() {
    var roomGroupsClasses = clsx({
      'active': this.props.active_tab == 'room_groups',
      'tab-pane': true
    })
    var inputs = this.props.all_room_groups.map(room_group => {
      return {
        label_primary: room_group.identifier,
        label_secondary: room_group.room_identifiers,
        id: room_group.id
      }
    })
    return (
      <div className={roomGroupsClasses} id="room_groups">
        { this.renderErrors() }
        <div className="row">
          <div className="col-md-12">
          { inputs.length
          ?
            <MultiSelect 
              header_primary="room_group_identifier"
              header_secondary="room_ids"
              inputs={inputs}
              selected_inputs={this.props.room_groups}
              onChange={this.props.onChangeRoomGroups}/>
          : 
            <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
          }
          </div>
        </div>        
      </div>  
    )
  }

  renderErrors() {
    var errors = RoomTypeBuilderErrors.room_groups(this.props.errors)
    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })
      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }
}

export default RoomTypeBuilderRoomGroups